function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Table } from 'react-bootstrap';
import { Skeleton, Button, Space, Popover, Statistic, Form, Select, notification, DatePicker, Alert, Tag } from 'antd';
import { XLg, ThreeDots, PeopleFill, PersonFillCheck, XCircleFill, CheckCircleFill, PersonFillExclamation, EnvelopeCheckFill, EnvelopeExclamationFill, ForwardFill } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import Moment from "react-moment";
import moment from "moment";
var RangePicker = DatePicker.RangePicker;
import { Chart } from "react-google-charts";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var SendReport = function SendReport(_ref) {
  var companies = _ref.companies;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState(moment().startOf("week").format()),
    _useState4 = _slicedToArray(_useState3, 2),
    from = _useState4[0],
    setFrom = _useState4[1];
  var _useState5 = useState(moment().endOf("week").format()),
    _useState6 = _slicedToArray(_useState5, 2),
    to = _useState6[0],
    setTo = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    customers = _useState8[0],
    setCustomers = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    stats = _useState0[0],
    setStats = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    open = _useState10[0],
    setOpen = _useState10[1];
  var ref = useRef();
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var handleOpenChange = function handleOpenChange(newOpen) {
    setOpen(newOpen);
  };
  var loadData = function loadData() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    setIsDataLoading(true);
    axios.post("".concat(Common.baseApiUrl, "getperiodiccompanycostumers"), {
      company_id: data == null ? 0 : data.company_id,
      user_id: Common.currentUser.id,
      from: data == null ? from : moment(data.period[0].$d).format(),
      protocole: data == null ? "0" : data.protocole,
      to: data == null ? to : moment(data.period[1].$d).format(),
      candidate_code: 'undefined'
    }).then(function (response) {
      if (response.data.status == 200) {
        setCustomers(response.data.customers);
      } else {
        notification.error({
          message: "Erreur",
          description: response.data.message,
          delay: 4
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur",
        description: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      protocole: "0",
      company_id: 0
    });
    loadData();
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [/*#__PURE__*/_jsxs("div", {
            style: {
              padding: "12px",
              background: "#FFFFFF",
              borderRadius: "6px",
              boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px"
            },
            children: [/*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsxs(Tag, {
                color: "#f50",
                children: ["P\xE9riode du ", /*#__PURE__*/_jsx(Moment, {
                  date: from,
                  format: "DD/MM/YYYY HH:mm"
                }), " au ", /*#__PURE__*/_jsx(Moment, {
                  date: to,
                  format: "DD/MM/YYYY HH:mm"
                })]
              }), /*#__PURE__*/_jsx(Popover, {
                placement: "topLeft",
                open: open,
                trigger: "click",
                onOpenChange: handleOpenChange,
                title: "FILTRES",
                content: /*#__PURE__*/_jsx(Form, {
                  form: form,
                  layout: "vertical",
                  onFinish: function onFinish(values) {
                    loadData(values);
                  },
                  children: /*#__PURE__*/_jsxs(Space, {
                    direction: "vertical",
                    children: [/*#__PURE__*/_jsx(Form.Item, {
                      label: "Soci\xE9t\xE9",
                      name: "company_id",
                      children: /*#__PURE__*/_jsx(Select, {
                        options: companies,
                        style: {
                          width: "100%"
                        }
                      })
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "protocole",
                      children: /*#__PURE__*/_jsx(Select, {
                        placeholder: "Protocole",
                        options: [{
                          value: "0",
                          label: "Tout"
                        }, {
                          value: "rio",
                          label: "RIO"
                        }, {
                          value: "emg",
                          label: "EMG"
                        }],
                        style: {
                          width: "100%"
                        }
                      })
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "period",
                      rules: [{
                        required: true,
                        message: "Veuillez choisir une période"
                      }],
                      children: /*#__PURE__*/_jsx(RangePicker, {})
                    }), /*#__PURE__*/_jsxs(Space, {
                      direction: "horizontal",
                      children: [/*#__PURE__*/_jsx(Form.Item, {
                        children: /*#__PURE__*/_jsx(Button, {
                          type: "primary",
                          htmlType: "submit",
                          children: /*#__PURE__*/_jsx("b", {
                            children: "FILTRER"
                          })
                        })
                      }), /*#__PURE__*/_jsx(Form.Item, {
                        children: /*#__PURE__*/_jsx(Button, {
                          loading: isDataLoading,
                          type: "link",
                          onClick: function onClick() {
                            setOpen(false);
                          },
                          icon: /*#__PURE__*/_jsx(XLg, {
                            size: 24
                          }),
                          children: " Fermer"
                        })
                      })]
                    })]
                  })
                }),
                children: /*#__PURE__*/_jsx(Button, {
                  size: "small",
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(ThreeDots, {
                      size: 20
                    })
                  })
                })
              })]
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsxs(Col, {
                lg: 8,
                md: 8,
                children: [/*#__PURE__*/_jsxs(Row, {
                  children: [/*#__PURE__*/_jsx(Col, {
                    lg: 4,
                    md: 4,
                    sm: 6,
                    children: /*#__PURE__*/_jsx("div", {
                      style: {
                        padding: "9px",
                        borderRadius: "4px",
                        background: "#E6EDEE"
                      },
                      children: /*#__PURE__*/_jsx(Statistic, {
                        prefix: /*#__PURE__*/_jsx(PeopleFill, {
                          size: 35
                        }),
                        title: /*#__PURE__*/_jsx("b", {
                          children: "Total Re\xE7u"
                        }),
                        value: customers.length
                      })
                    })
                  }), /*#__PURE__*/_jsx(Col, {
                    lg: 4,
                    md: 4,
                    sm: 6,
                    children: /*#__PURE__*/_jsx("div", {
                      style: {
                        padding: "9px",
                        borderRadius: "4px",
                        background: "#ECEEE6"
                      },
                      children: /*#__PURE__*/_jsx(Statistic, {
                        prefix: /*#__PURE__*/_jsx(PersonFillExclamation, {
                          style: {
                            color: "#A97D5C"
                          },
                          size: 35
                        }),
                        title: /*#__PURE__*/_jsx("b", {
                          children: "En attente validation"
                        }),
                        value: customers.filter(function (c) {
                          return c.status == 0;
                        }).length
                      })
                    })
                  }), /*#__PURE__*/_jsx(Col, {
                    lg: 4,
                    md: 4,
                    sm: 6,
                    children: /*#__PURE__*/_jsx("div", {
                      style: {
                        padding: "9px",
                        borderRadius: "4px",
                        background: "#EEEBEB"
                      },
                      children: /*#__PURE__*/_jsx(Statistic, {
                        prefix: /*#__PURE__*/_jsx(PersonFillCheck, {
                          style: {
                            color: "#437D6C"
                          },
                          size: 35
                        }),
                        title: /*#__PURE__*/_jsx("b", {
                          children: "Total valid\xE9(s)"
                        }),
                        value: customers.filter(function (c) {
                          return c.status == 1;
                        }).length
                      })
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
                  children: [/*#__PURE__*/_jsx(Col, {
                    lg: 4,
                    md: 4,
                    sm: 6,
                    children: /*#__PURE__*/_jsx("div", {
                      style: {
                        padding: "9px",
                        borderRadius: "4px",
                        background: "#EEECEC"
                      },
                      children: /*#__PURE__*/_jsx(Statistic, {
                        prefix: /*#__PURE__*/_jsx(EnvelopeExclamationFill, {
                          style: {
                            color: "#A97D5C"
                          },
                          size: 35
                        }),
                        title: /*#__PURE__*/_jsx("b", {
                          children: "Attend d'envoie"
                        }),
                        value: customers.filter(function (c) {
                          return c.status == 1 && c.conclusion && c.conclusion.last_send_at == null;
                        }).length
                      })
                    })
                  }), /*#__PURE__*/_jsx(Col, {
                    lg: 4,
                    md: 4,
                    sm: 6,
                    children: /*#__PURE__*/_jsx("div", {
                      style: {
                        padding: "9px",
                        borderRadius: "4px",
                        background: "#EDECEE"
                      },
                      children: /*#__PURE__*/_jsx(Statistic, {
                        prefix: /*#__PURE__*/_jsx(EnvelopeCheckFill, {
                          style: {
                            color: "#437D6C"
                          },
                          size: 35
                        }),
                        title: /*#__PURE__*/_jsx("b", {
                          children: "Envoy\xE9(s)"
                        }),
                        value: customers.filter(function (c) {
                          return c.conclusion && c.conclusion.last_send_at != null;
                        }).length
                      })
                    })
                  }), /*#__PURE__*/_jsx(Col, {
                    lg: 4,
                    md: 4,
                    sm: 6,
                    children: /*#__PURE__*/_jsx("div", {
                      style: {
                        padding: "9px",
                        borderRadius: "4px",
                        background: "#EEECEC"
                      },
                      children: /*#__PURE__*/_jsx(Statistic, {
                        prefix: /*#__PURE__*/_jsx(ForwardFill, {
                          style: {
                            color: "#9D4B4B"
                          },
                          size: 35
                        }),
                        title: /*#__PURE__*/_jsx("b", {
                          children: "Ref\xE9r\xE9(s)"
                        }),
                        value: customers.filter(function (c) {
                          return c.status == 2;
                        }).length
                      })
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {})]
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                children: /*#__PURE__*/_jsx(Chart, {
                  chartType: "PieChart",
                  data: [["item", "value"], ["Attente validation", customers.filter(function (c) {
                    return c.status == 0;
                  }).length], ["Total Validés", customers.filter(function (c) {
                    return c.status == 1;
                  }).length], ["Attente envoie", customers.filter(function (c) {
                    return c.status == 1 && c.conclusion != null && c.conclusion.last_send_at == null;
                  }).length], ["Total Envoyés", customers.filter(function (c) {
                    return c.conclusion != null && c.conclusion.last_send_at != null;
                  }).length], ["Total Reférés", customers.filter(function (c) {
                    return c.status == 2;
                  }).length]],
                  colors: ["#9F8AD1"],
                  width: "100%",
                  height: "300px",
                  options: {
                    title: "Traitement des dossiers",
                    legend: {
                      position: "bottom"
                    },
                    colors: ["#A9675C", "#6F8B8A", "#8AD1C2", "#D18A99", "#BCD18A"],
                    lineWidth: 1,
                    is3D: true,
                    pieStartAngle: 100,
                    // Rotates the chart
                    sliceVisibilityThreshold: 0.02,
                    animation: {
                      duration: 5000,
                      easing: "out"
                    }
                  }
                })
              })]
            })]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
            style: {
              padding: "12px",
              background: "#FFFFFF",
              borderRadius: "6px",
              boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px"
            },
            children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Table, {
              responsive: true,
              striped: true,
              bordered: true,
              children: [/*#__PURE__*/_jsx("thead", {
                children: /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("th", {
                    children: "Re\xE7u le"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Code D."
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Cat."
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Nom"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Valid."
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Cert."
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Envoy\xE9"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Envoy\xE9 le"
                  })]
                })
              }), /*#__PURE__*/_jsx("tbody", {
                children: customers.map(function (c) {
                  return /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Moment, {
                        date: c.created_at,
                        format: "DD/MM/YYYY"
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: c.candidate_code
                    }), /*#__PURE__*/_jsx("td", {
                      children: c.category != 0 && c.category != 1 && c.category
                    }), /*#__PURE__*/_jsx("td", {
                      children: c.name
                    }), /*#__PURE__*/_jsx("td", {
                      children: c.status == 1 ? /*#__PURE__*/_jsx(CheckCircleFill, {
                        style: {
                          color: "#4B9D78"
                        },
                        size: 12
                      }) : /*#__PURE__*/_jsx(XCircleFill, {
                        style: {
                          color: "#9D614B"
                        },
                        size: 12
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: c.conclusion != null && c.conclusion.file != null ? /*#__PURE__*/_jsx(CheckCircleFill, {
                        style: {
                          color: "#4B9D78"
                        },
                        size: 12
                      }) : /*#__PURE__*/_jsx(XCircleFill, {
                        style: {
                          color: "#9D614B"
                        },
                        size: 12
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: c.conclusion != null && c.conclusion.last_send_at != null ? /*#__PURE__*/_jsx(CheckCircleFill, {
                        style: {
                          color: "#4B9D78"
                        },
                        size: 12
                      }) : /*#__PURE__*/_jsx(XCircleFill, {
                        style: {
                          color: "#9D614B"
                        },
                        size: 12
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: c.conclusion != null && (c.conclusion.last_send_at == null ? "" : /*#__PURE__*/_jsx(Moment, {
                        date: c.conclusion.last_send_at,
                        format: "DD/MM/YYYY"
                      }))
                    })]
                  }, c.id);
                })
              })]
            })]
          }), /*#__PURE__*/_jsx("br", {}), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
            active: true
          })]
        })
      })
    })
  });
};
export default SendReport;